import axios, { AxiosPromise } from 'axios';

import { IPackCategory } from '../../../@types/model/masterData/packCategory/packCategory';

export default class PackCategoryHttpService {
    public static getPackCategoryData() : AxiosPromise<Array<IPackCategory>> {
        return axios.get(`${API_URL}/v1/PackCategory/GetAllWeb`);
    }

    public static addOrUpdatePackCategory(data : IPackCategory) : AxiosPromise<IPackCategory> {
        return axios.post(`${API_URL}/v1/PackCategory/PostPackCategory`, data);
    }

    public static deletePackCategory(packCategoryId : number) : AxiosPromise<IPackCategory> {
        return axios.delete(`${API_URL}/v1/PackCategory/Delete`, {
            params : { packCategoryId },
        });
    }
}
